<script lang="ts">
    import cn from 'classnames';

    import s from '../styles.module.css';

    export let isBig = false;
    export let classes = '';
</script>

<ol class={cn(s.numberList, { [s.big]: isBig }, classes)}><slot /></ol>
